module.exports = __webpack_public_path__ + "static/media/study 220425.2727a80e.png";